import { safeReturnTo } from "~/utils/safeReturnTo";

/** Map a button `redirect` prop to a returnTo path: string → validated
 *  same-site path (or undefined if unsafe), true → "/orders", false/undefined
 *  → undefined.
 *
 *  This IS the guard, not a second one: SsoButton is the only caller, and the
 *  value reaches it unvalidated — login.vue passes `route.query.redirect`
 *  straight through to LoginForm (login.vue:22). So a crafted
 *  `?redirect=https://evil.com` or `//evil.com` is stopped here, before the
 *  path is signed into the WorkOS state and handed back to the callback page. */
export function resolveRedirect(redirect: boolean | string | undefined): string | undefined {
  if (typeof redirect === "string") return safeReturnTo(redirect);
  return redirect ? "/orders" : undefined;
}
